import styled, { css } from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { UbuntuFontFamily } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const NavItem = styled.li `
  list-style-type: none;
  margin-top: 12px;
  position: relative;

  img {
    position: relative;
  }
`;
export const NavItemLink = styled.span `
  ${UbuntuFontFamily};
  position: relative;

  ${getTextStyles('Ubuntu', 400, 14, 24)}

  color: ${colorCoreWhite1000};
  text-decoration: none;

  ${({ isRightToLeft }) => isRightToLeft ? `padding-left: ${INDENT.s};` : `padding-right: ${INDENT.s};`};

  &:hover {
    text-decoration: underline;
  }

  ${({ isExternalLink, iconUrl, isRightToLeft }) => isExternalLink &&
    css `
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        display: block;
        width: 16px;
        height: 16px;

        transform: translate(0, -50%);

        ${isRightToLeft ? 'left' : 'right'}: 0;
        ${iconUrl && `background-image: url(${iconUrl})`};
      }
    `};
`;
